import { CATALOGUE_EVENTS } from '../../event_bus_modules/properties_in_catalogue';

$(() => {
  const bankTransferDisclaimerModal = $('#bank-transfer-disclaimer');
  bankTransferDisclaimerModal.modal({ backdrop: 'static', keyboard: false });
  bankTransferDisclaimerModal.modal('show');

  EVENT_BUS.on(CATALOGUE_EVENTS.REMOVED_FROM_CATALOGUE, ({ id, data }) => {
    removePropertyItem(id);
  });

  EVENT_BUS.on(CATALOGUE_EVENTS.ALL_PROPERTIES_REMOVED, () => {
    showSectionAfterRemovingAllProperties();
    setTimeout(() => {
      window.location.href = '/';
    }, 15000);
  });

  const showSectionAfterRemovingAllProperties = () => {
    $('#no-properties-in-cart-text').show();
  };

  const removePropertyItem = (propertyId) => {
    const auctionPropertySection = $(
      `.auction-property[entity-id='${propertyId}']`
    );
    const auctionSection = auctionPropertySection.parent();
    auctionPropertySection.remove();

    const hasAuctionProperties = auctionSection.find('.auction-property')
      .length;
    if (!hasAuctionProperties) {
      auctionSection.remove();
    }
    if ($(`#cancel-registration-modal-${propertyId}`)) {
      $(`#cancel-registration-modal-${propertyId}`).modal('hide');
    }
  };

  $('button[name="cancel-registration-button"]').on('click', ($event) => {
    const entityId = $event.target.getAttribute('entity-id');
    const cancelRegModal = $(`#cancel-registration-modal-${entityId}`);

    $($event.target).toggleClass('active');
    const position = $($event.target).position();

    cancelRegModal.modal({
      backdrop: false,
      show: true,
    });
    const modalContent = cancelRegModal.find('.modal-dialog');
    const additionalMargin = 40;
    let newTopPosition =
      position.top - $(window).scrollTop() - modalContent.height() / 2;
    const hidesOnBottom =
      newTopPosition + modalContent.height() - window.innerHeight < 0
        ? false
        : true;
    newTopPosition = hidesOnBottom
      ? window.innerHeight - modalContent.height() - additionalMargin
      : newTopPosition;

    modalContent.css({
      top: newTopPosition > 0 ? newTopPosition : 0,
    });
  });

  $('.close-button').on('click', ($event) => {
    const modalContent = $($event.target).closest('.modal-content');
    const entityId = modalContent.data('entity-id');
    if (entityId) {
      $(
        `button[entity-id="${entityId}"][name="cancel-registration-button"]`
      ).toggleClass('active');
    }
  });
});
